// Última página visitada de cada listado, por ruta y plantel, en sessionStorage.
//
// Por qué (Esteban, 2026-09-11): al abrir el perfil o el estado de cuenta de un
// alumno y volver, el módulo se monta de cero y cae en la página 1, así que la
// gente perdía tiempo paginando de nuevo. Aquí se recuerda la página y el
// módulo la retoma al montarse. Buscar, Limpiar, cambiar de plantel o de tamaño
// de página la olvidan, porque ahí sí se quiere empezar desde la primera.
//
// sessionStorage (no localStorage): vive mientras la pestaña esté abierta y
// muere con ella, que es exactamente la duración de una sesión de trabajo.

let campusActual: any = null

export const fijarCampusPagina = (campusId: any) => { campusActual = campusId }

const clave = () => `wapp:pagina:${window.location.pathname}:${campusActual ?? ""}`

export function recordarPagina(page: any): void
{
	const n = Number(page)
	if(Number.isFinite(n) && n >= 1)
	{
		try { sessionStorage.setItem(clave(), String(n)) } catch { /* modo privado, etc. */ }
	}
}

export function olvidarPagina(): void
{
	try { sessionStorage.removeItem(clave()) } catch { /* nada */ }
}

export function paginaRecordada(): number
{
	try
	{
		const n = Number(sessionStorage.getItem(clave()))
		return Number.isFinite(n) && n >= 1 ? n : 1
	}
	catch { return 1 }
}

/** Para los módulos clásicos: search(page). Si viene una página explícita
 *  (clic en la paginación) se recuerda y se usa; si no viene (montaje del
 *  módulo, Buscar, Limpiar) se usa la recordada, que Buscar/Limpiar ya
 *  borraron desde el contenedor. Un evento de clic u otro valor no numérico
 *  cuenta como "no viene". */
export function paginaInicial(page?: any): number
{
	const n = Number(page)
	if(page !== undefined && page !== null && typeof page !== "object" && Number.isFinite(n) && n >= 1)
	{
		recordarPagina(n)
		return n
	}
	return paginaRecordada()
}
